/**
 * sz-business-page.js — Business Inquiry Page interactions
 * Sections: Scroll reveal, Brands marquee, Stats count-up,
 *           Video testimonials, FAQ accordion, Smooth scroll,
 *           Form validation
 */
(function() {
  'use strict';

  // Guard against double-init
  if (window.__szBizPageInit) return;
  window.__szBizPageInit = true;

  function init() {

    /* --- Scroll Reveal (IntersectionObserver) --- */
    var revealEls = document.querySelectorAll('[data-sz-reveal]');

    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

      revealEls.forEach(function(el) {
        revealObserver.observe(el);
      });

      /* Fallback: if elements are still invisible after 2s (Shopify preview mode
         can delay rendering), force them visible */
      setTimeout(function() {
        revealEls.forEach(function(el) {
          if (!el.classList.contains('is-visible')) {
            el.classList.add('is-visible');
          }
        });
      }, 2000);
    } else {
      /* No IntersectionObserver support — show everything immediately */
      revealEls.forEach(function(el) {
        el.classList.add('is-visible');
      });
    }

    /* --- Logo Marquee: measure scroll distance --- */
    (function() {
      var track = document.querySelector('.sz-brands-track');
      if (!track) return;
      function measure() {
        var imgs = track.querySelectorAll('img');
        var half = imgs.length / 2;
        if (half < 1 || !imgs[Math.floor(half)]) return;
        var offset = imgs[Math.floor(half)].offsetLeft;
        if (offset > 0) {
          track.style.setProperty('--sz-scroll-distance', '-' + offset + 'px');
        }
      }
      if (document.readyState === 'complete') measure();
      else window.addEventListener('load', measure);
      window.addEventListener('resize', measure);
    })();

    /* --- Stats Count-Up (3s cubic easing) --- */
    var countObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.dataset.count);
        var suffix = el.dataset.suffix || '+';
        var duration = 3000;
        var start = performance.now();

        function tick(now) {
          var progress = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = Math.floor(eased * target);
          el.textContent = current.toLocaleString() + suffix;
          if (progress < 1) requestAnimationFrame(tick);
        }

        requestAnimationFrame(tick);
        countObserver.unobserve(el);
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('[data-count]').forEach(function(el) {
      countObserver.observe(el);
    });

    /* --- Video Testimonials: click to play/pause --- */
    document.querySelectorAll('.testi__card').forEach(function(card) {
      var video = card.querySelector('video');
      var play = card.querySelector('.testi__play');
      if (!video) return;

      function toggleVideo() {
        var scrim = card.querySelector('.testi__scrim');
        var quote = card.querySelector('.testi__quote');
        var company = card.querySelector('.testi__company');

        if (video.paused) {
          video.muted = false;
          video.controls = true;
          video.play().catch(function(){});
          if (play) play.style.display = 'none';
          if (scrim) scrim.style.display = 'none';
          if (quote) quote.style.display = 'none';
          if (company) company.style.display = 'none';
        } else {
          video.pause();
          video.controls = false;
          if (play) play.style.display = 'flex';
          if (scrim) scrim.style.display = '';
          if (quote) quote.style.display = '';
          if (company) company.style.display = '';
        }
      }

      card.addEventListener('click', toggleVideo);

      if (play) {
        play.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleVideo();
          }
        });
      }
    });

    /* --- FAQ Accordion (single-open, global function for onclick) --- */
    window.toggleFaqF = function(btn) {
      var item = btn.parentElement;
      var body = item.querySelector('.oFQ-body');
      var isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.oFQ-item.open').forEach(function(el) {
        el.classList.remove('open');
        el.querySelector('.oFQ-body').style.maxHeight = null;
        el.querySelector('.oFQ-trigger').setAttribute('aria-expanded', 'false');
      });

      // Open clicked if wasn't open
      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    };

    /* --- Smooth Scroll for anchor links (respects reduced motion + focus) --- */
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector(link.getAttribute('href'));
        if (target) {
          target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
      });
    });

    /* --- UTM / gclid tracking --- */
    (function() {
      var params = new URLSearchParams(window.location.search);
      var fields = ['gclid','utm_source','utm_medium','utm_campaign','utm_term','utm_content'];
      fields.forEach(function(f) {
        var v = params.get(f);
        if (v) sessionStorage.setItem(f, v);
        var el = document.getElementById(f);
        var stored = sessionStorage.getItem(f);
        if (el && stored) el.value = stored;
      });
    })();

    /* --- B2B Form: phone + validation + calendar booking --- */
    var frm = document.getElementById('ContactB2B');
    if (frm) {
      var calendarUrl = 'https://calendar.google.com/calendar/u/0/appointments/AcZssZ29NqdtpCYL6nArB8aEsgn6wvBkKZD_j5ruLmQ=';

      frm.addEventListener('submit', function(e) {
        var firstInvalid = null;

        ['ContactName', 'ContactEmail'].forEach(function(id) {
          var el = document.getElementById(id);
          if (!el) return;
          var empty = el.value.trim() === '';
          if (empty) { el.classList.add('field-error'); if (!firstInvalid) firstInvalid = el; }
          else { el.classList.remove('field-error'); }
        });

        // Phone: combine country code + digits into hidden field
        var cc   = document.getElementById('PhoneCC');
        var num  = document.getElementById('PhoneNum');
        var hid  = document.getElementById('ContactPhone');
        var wrap = document.getElementById('PhoneWrap');
        var err  = document.getElementById('PhoneError');

        if (cc && num && hid) {
          var digits = (num.value || '').replace(/\D/g, '').slice(0, 15);
          if (digits.length < 7) {
            if (wrap) wrap.classList.add('field-error');
            if (err) err.style.display = 'block';
            if (!firstInvalid) firstInvalid = num;
          } else {
            if (wrap) wrap.classList.remove('field-error');
            if (err) err.style.display = 'none';
            hid.value = (cc.value || '+1') + digits;
          }
        }

        if (firstInvalid) {
          e.preventDefault();
          firstInvalid.focus({ preventScroll: false });
          return false;
        }

        // Open calendar for orders 6+ pairs
        var qtyEl = document.getElementById('ContactQty');
        if (qtyEl && qtyEl.value) {
          var txt = qtyEl.options[qtyEl.selectedIndex] ? qtyEl.options[qtyEl.selectedIndex].text : '';
          var m = txt.match(/\d+/);
          if (m && parseInt(m[0], 10) >= 6) {
            window.open(calendarUrl, '_blank', 'noopener,noreferrer');
          }
        }
      });
    }

  }

  // Handle case where DOMContentLoaded already fired
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
